import React, { useState } from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import { Close } from '@mui/icons-material';
import Grid from '@mui/material/Grid';
import { formStyles } from '../../../util/styles';
import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import { FormControl, FormLabel } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import CreatableGroupSelect from '../CreatableGroupSelect';
import axios from 'axios';

const AddUserModal = ({ open, onClose }) => {
  const classes = formStyles();
  const [userInfo, setUserInfo] = useState({});
  const [errors, setErrors] = useState([]);

  const handleClose = () => {
    setUserInfo({});
    setErrors([]);
    onClose(false);
  };

  const handleSubmit = async () => {
    let errorList = [];

    if (!userInfo.name) {
      errorList.push('Name must be populated');
    }

    if (!userInfo.email || !userInfo.email.includes('@')) {
      errorList.push('Email is not valid');
    }

    if (!userInfo.groupName) {
      errorList.push('User must be part of a group');
    }

    if (errorList.length > 0) {
      setErrors(errorList);
    } else {
      try {
        const createUserBody = {
          name: userInfo.name,
          email: userInfo.email,
          groups: [userInfo.groupID],
          role: userInfo.role,
        };
        const res = await axios.post('/api/user', createUserBody);

        if (res.data.error) {
          setErrors([res.data.error]);
        } else {
          setUserInfo({});
          onClose(true);
          setErrors([]);
        }
      } catch (error) {
        setErrors(["Failed to add user. Likely caused by bad email address."])
      }
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
      className={classes.form}
    >
      <DialogTitle sx={{ pr: 6 }}>
        Add User
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{ position: 'absolute', right: 8, top: 8, color: 'grey.500' }}
          size="large">
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Collapse in={errors && errors.length > 0}>
          <Alert severity="error" className={classes.alert}>
            Add Failed:
            <ul>
              {errors.map((error) => (
                <li key={error}>{error}</li>
              ))}
            </ul>
          </Alert>
        </Collapse>
        <Grid container spacing={2}>
          <Grid size={12}>
            <TextField
              size="small"
              variant="outlined"
              fullWidth
              id="name"
              name="name"
              label="Name"
              autoFocus
              value={userInfo.name}
              onChange={(event) =>
                setUserInfo({
                  ...userInfo,
                  name: event.target.value,
                })
              }
            />
          </Grid>
          <Grid size={12}>
            <TextField
              size="small"
              variant="outlined"
              fullWidth
              id="email"
              name="email"
              label="Email"
              value={userInfo.email}
              onChange={(event) =>
                setUserInfo({
                  ...userInfo,
                  email: event.target.value,
                })
              }
            />
          </Grid>
          <Grid size={12}>
            <FormLabel component={'legend'}>Group</FormLabel>
            <CreatableGroupSelect
              create={true}
              value={{
                label: userInfo.groupName,
                value: userInfo.groupID,
              }}
              onChange={(group) => {
                setUserInfo({
                  ...userInfo,
                  groupName: group.label,
                  groupID: group.value,
                });
              }}
            />
          </Grid>
          <Grid size={12}>
            <FormControl component={'fieldset'}>
              <FormLabel component={'legend'}>User Role</FormLabel>
              <RadioGroup
                value={userInfo.role ? userInfo.role : 'User'}
                onChange={(e) => {
                  setUserInfo({
                    ...userInfo,
                    role: e.target.value,
                  });
                }}
              >
                <Grid container>
                  <Grid>
                    <FormControlLabel
                      control={<Radio />}
                      value={'User'}
                      label={'User'}
                    />
                  </Grid>
                  <Grid>
                    <FormControlLabel
                      control={<Radio />}
                      value={'Admin'}
                      label={'Admin'}
                    />
                  </Grid>
                </Grid>
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button
          onClick={handleSubmit}
          color="primary"
          variant="contained"
        >
          Save
        </Button>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddUserModal;
